export default __webpack_public_path__ + "static/cabezote-ganadoras-7048b5c3bf6d41fd46b6ad3c3efdde81.png";